import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Box } from 'styled-system/jsx';
import { getAdjusterRankQueryOptions } from '../../queries/getAdjusterRank/getAdjusterRankQueryOptions';
import { getAdjusterRankpositionQueryOptions } from '../../queries/getAdjusterRankposition/getAdjusterRankpositionQueryOptions';
import { getAdjustersListQueryOptions } from '../../queries/getAdjustersList/getAdjustersListQueryOptions';
import { TabItem } from '../../types/CustomTab.type';
import CustomTabs from '../common/CustomTab';
import MyRanking from './MyRanking';
import RankingList from './RankingList';

export default function RankingSection() {
  const [activeTab, setActiveTab] = useState<'country' | 'province'>('country');

  const { data: AdjusterData } = useQuery(
    getAdjusterRankpositionQueryOptions(),
  );

  const { data: MyRankingData, isPending: isMyRankingPending } = useQuery(
    getAdjusterRankQueryOptions({ rank_type: 'adjuster' }),
  );

  const { data, isPending, fetchNextPage, isFetchingNextPage } =
    useInfiniteQuery(
      getAdjustersListQueryOptions({
        rank_type: activeTab === 'country' ? 'all' : 'province',
      }),
    );

  const adjusterListResult = data?.pages.flatMap((p) => p.results) ?? [];

  const results = MyRankingData?.results ?? [];

  const tabs: TabItem[] = [
    {
      id: 'tab-1',
      label: `کشوری (${AdjusterData?.national_adjusters} کارشناس)`,
      content: (
        <MyRanking
          MyRankingData={results}
          isProvince={false}
          isLoading={isMyRankingPending}
        />
      ),
    },
    {
      id: 'tab-2',
      label: `استان (${AdjusterData?.province_adjusters} کارشناس)`,
      content: (
        <MyRanking
          MyRankingData={results}
          isProvince={true}
          isLoading={isMyRankingPending}
        />
      ),
    },
  ];

  return (
    <Box>
      <Box
        position="sticky"
        top="66px"
        zIndex="layout"
        bg="gray-4"
        paddingTop="28px"
        paddingBottom="16px"
      >
        <CustomTabs
          items={tabs}
          defaultActiveId="tab-1"
          variant="full"
          onChange={(id) =>
            setActiveTab(id === 'tab-1' ? 'country' : 'province')
          }
        />
      </Box>

      <RankingList
        data={adjusterListResult}
        fetchNextPage={fetchNextPage}
        activeTab={activeTab}
        isLoading={isPending}
        isFetchingNextPage={isFetchingNextPage}
      />
    </Box>
  );
}
